<template lang="pug">
  .selected-box(data-testid="selected-tag")
    tag-color.label.bcard-tag(v-for="(tag, index) in value", :key="tag.id", :class="{'view': view_mode}", :rgb="tag.color_rgb", :outline="getOutline(tag)", :title="tag.name" :data-testid="tag.name")
      input(type="hidden", :name="inputName", v-model="tag.id")
      | {{tag.name}}
      i.fa.fa-times(v-if="!view_mode" @click="removeSelectedTag(index)" data-testid="-icon-remove-tag")
</template>

<script>
import TagColor from '@/components/molecules/TagColor'
export default {
  name: 'SelectedTag',
  components: { TagColor },
  props: {
    value: {
      type: Array,
      required: false,
      default: function () {
        return []
      }
    },
    inputName: {type: String, required: false, default: 'tags[]'},
    view_mode: {type: Boolean, required: false, default: true} // 表示モード
  },
  methods: {
    removeSelectedTag: function (index) {
      this.$emit('remove', index)
    },
    getOutline: function (item) {
      return item.openflag === this.app_flag.OFF
    }
  }
}
</script>

<style lang="scss" scoped>
.selected-box {
  .bcard-tag {
    margin-right: 5px;
    margin-bottom: 5px;
    padding-right: 20px;

    font-size: 14px;
    font-weight: normal;
    display: block;
    float: left;
    color: #333;
    text-shadow: -1px -1px 1px rgba(255,255,255,.8),
                 -1px -1px 1px rgba(255,255,255,.8),
                  1px -1px 1px rgba(255,255,255,.8),
                  1px -1px 1px rgba(255,255,255,.8),
                 -1px  1px 1px rgba(255,255,255,.8),
                 -1px  1px 1px rgba(255,255,255,.8),
                  1px  1px 1px rgba(255,255,255,.8),
                  1px  1px 1px rgba(255,255,255,.8);

    position: relative;
    max-width: 16em;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;

    &.view {
      padding-right: .6em;
    }
  }

  .fa-times {
    cursor: pointer;
    margin-left: .5em;
    position: absolute;
    right: 5px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/molecules/SelectedTag.vue